import React from 'react';

// written to handle one announcement right now
const Banner = ({ text, url }) => (
    <a className="app-banner" href={url}>
        <p className="container">{text}</p>
    </a>
);

export default Banner;